export const fileExtensions = new Set([
    'ifc',
    'smdx',
    'wdx',
    'dwp',
    'dxf',
]);
